import type { ContactEmailData } from 'common/src/email/sendMail';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import { postRequest } from 'portal/src/api/requestTypes';

export const sendContactRequest = async (
  body: Omit<ContactEmailData, 'userEmail'>,
): Promise<void> => await postRequest(API_BASE_PATHS.CONTACT_US, {}, body);
